export const SSO_GET = 'SSO_GET'
export const SSO_UPDATE = 'SSO_UPDATE'
export const SSO_ERROR = 'SSO_ERROR'
export const SSO_LINK_POST = 'SSO_LINK_POST'

export function getSSO(payload = {}) {
  return {
    type: SSO_GET,
    payload,
  }
}

export function updateSSO(payload = {}) {
  return {
    type: SSO_UPDATE,
    payload,
  }
}

export function errorSSO(payload = {}) {
  return {
    type: SSO_ERROR,
    payload,
  }
}

export function postSSOLink(payload = {}) {
  return {
    type: SSO_LINK_POST,
    payload,
  }
}
